import gql from 'graphql-tag';

const mutation = gql`
    mutation SalePaymentClone($token: String!, $source: String) {
        sale {
            clonePayment(token: $token, source: $source) {
                ... on Payment {
                    token
                }
            }
        }
    }
`;

export default mutation;
